export default __webpack_public_path__ + "static/media/debt-cash.8c1f6403.svg";